export const UserSiteDetails = {
    GET_USERSWITHSITES: "GET_USERSWITHSITES",
    GET_SITESBYUSERID: "GET_SITESBYUSERID",
    POST_USERSWITHSITES: "POST_USERSWITHSITES",
    UPDATE_USERSWITHSITES: "UPDATE_USERSWITHSITES",
    DELETE_USERSWITHSITES: "DELETE_USERSWITHSITES",
}
